export enum fileTypeExtensions {
  CSV = 'csv',
  JSON = 'json',
}

export const FileMimeType = {
  csv: 'text/csv',
  json: 'application/json',
};

export const downloadFileFromData = (
  data: any,
  fileName: string,
  fileType = fileTypeExtensions.CSV,
): void => {
  const blob = new Blob([data], { type: FileMimeType[fileType] });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${fileName}.${fileType}`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};
